// to be called in browser, shows elements that overflow document
$.whatOverflows = () => {
  const docWidth = document.documentElement.offsetWidth;

  [].forEach.call(document.querySelectorAll('*'), (element) => {
    if (element.offsetWidth > docWidth) {
      console.log(element);
    }
  });
};
